import { Typography } from "@mui/material";

interface Props {
  text?: string;
}

const NoDataResult = ({ text }: Props) => {
  return (
    <Typography color="textSecondary" sx={{ p: 1.5, textAlign: "center" }}>
      {text || "No data"}
    </Typography>
  );
};

export default NoDataResult;
